import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: []
};

const getters = {
  list_to_select: (state) => formatArrayToElSelect(state.list),
  getById: (state) => (id) => {
    return state.list.find((l) => l.Id === id);
  }
};

const actions = {
  getCurrency: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/currency/all")
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
